import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  variant?: 'gold' | 'ink' | 'outline';
  className?: string;
  microcopy?: string;
  currencyNote?: boolean;
};
const base = 'group inline-flex w-full items-center justify-center gap-2 rounded-2xl px-6 py-4 text-center text-[15px] font-extrabold uppercase tracking-[0.06em] leading-tight transition-[transform,background-color,color,box-shadow] duration-200 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold sm:text-base md:py-5 md:text-lg';
const variants: Record<string, string> = {
  gold: 'bg-gold text-ink shadow-cta hover:bg-gold-light active:scale-[0.985]',
  ink: 'bg-ink text-cream shadow-float hover:bg-ink-soft active:scale-[0.985]',
  outline: 'border border-gold/60 bg-transparent text-ink hover:bg-gold-pale active:scale-[0.985]'
};
export function CtaButton({
  label,
  variant = 'gold',
  className = '',
  microcopy,
  currencyNote
}: CtaButtonProps) {
  return <div className={`w-full ${className}`} data-id="element-84" data-mp="39yhn1mmcjfbq">
      <a href={CHECKOUT_URL} className={`${base} ${variants[variant]}`} rel="noopener" data-id="element-85" data-mp="39z9ld57bvr5p">
        <span data-id="element-86" data-mp="3ezxatmfwrzxt">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-87" data-mp="3jwnpc5c2enh4" />
      </a>
      {microcopy && <p className="mt-3 text-center text-[13px] leading-relaxed text-clay" data-id="element-88" data-mp="3sxdjz5pla7t9">
          {microcopy}
        </p>}
      {currencyNote && <p className="mt-1 text-center text-[12px] italic text-clay/80" data-id="element-89" data-mp="1jhjiqhkhpl9">
          Your currency is converted automatically at checkout.
        </p>}
    </div>;
}